export enum Urls {
  FREE_CANCELLATION_ILLUSTRATION = 'https://a.travel-assets.com/travel-assets-manager/03052020/illustration__free__cancellation__sml.svg'
}
